var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_fd50340f1c710be9b5de332b894be6e76f88a5b261d9c7fcd6abf70be9a2ba36",
    x1: 84.5,
    y1: 25.24,
    x2: 113.25,
    y2: 25.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.91 51.05l11.94 76.34c0 3.29 12.36 6 27.59 6s27.59-2.67 27.59-6L139 51.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_fd50340f1c710be9b5de332b894be6e76f88a5b261d9c7fcd6abf70be9a2ba36)",
    d: "M85.75 25.24H112M98.88 58.23V40.17M85.75 46.74H112M85.75 53.11H112M85.75 32.08H112M85.75 57.86V40.17h26.26v18.02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M74.29 31.81H63.4V21.55a5.45 5.45 0 0110.89 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.85 16.21h49.08a5.37 5.37 0 015.45 5.26v35.41M74.3 31.74v25.47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M123.61 44.3c9.39 1.56 15.39 4 15.39 6.75 0 4.71-17.7 8.53-39.53 8.53s-39.53-3.82-39.53-8.53c0-2.64 5.54-5 14.25-6.56M137.28 61.87c-4.92 3.5-20 6.05-37.84 6.05s-32.75-2.52-37.75-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.d5f6848aeaf105c7f62f371b4b99bbe8.svg";
export { ForwardRef as ReactComponent };